// extracted by css-extract-rspack-plugin
export default {"primaryItem":"_1b9b3016","primaryLink":"_be4df9e3","primaryImage":"_d4c62364","productItems":"_4745c522","fullHeight":"_48652b23","shimmerLoadingBackground":"_5fc19102"};